/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 49:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 51:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 56:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 64:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 69:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 2 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 41:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 49:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 54:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 2 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 19:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 26:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 34:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 39:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 2 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');

    const CN_ACTIVE = '!active';

    customElements.define('slideshow-thumbnails', class extends Core {
        elements = {
            items: '*[data-item]'
        }
        
        async render() {
            if(!this.$ref) return;

            await this._initRefSlider();
            this._handleItemsClick();
            this._handleSlideChange();
        }

        async _initRefSlider() {
            await customElements.whenDefined(this.$ref.localName);
            this._updateActive();
        }

        _handleSlideChange() {
            this.$ref.slider.on(
                'slideChange', 
                this._updateActive.bind(this)
            );
        }

        _handleItemsClick() {
            this.$items.map(($item, index) => {
                $item.addEventListener(
                    'click', 
                    () => this.$ref.slider.slideTo(index)
                );
            })
        }

        _updateActive() {
            this.active = this.$ref.slider.activeIndex;
            this._scrollToActiveView();
        }

        _scrollToActiveView() {
            this.scroll(0, this.$activeItem.offsetTop - this.$activeItem.offsetHeight * 3);
        }

        get $ref() {
            return document.querySelector(this.getAttribute('ref'));
        }

        set active(index) {
            const $item = this.$items[index];
            if(this.$activeItem === $item) return;
            
            if(this.$activeItem) {
                this.$activeItem.classList.remove(CN_ACTIVE);
            }
            $item.classList.add(CN_ACTIVE);
            this.$activeItem = $item;
        }
    });
})();